import React, { FC, PropsWithChildren } from 'react'
import { LocalPath } from '../../common/intl/LocalPath'
import { LocaleLink } from '../../common/intl/LocaleLink'

interface Props extends PropsWithChildren {
  to: LocalPath | string
  title?: string
}

export const HeaderLinkAction: FC<Props> = ({ to, title, children }) => {
  return (
    <LocaleLink
      className="p-2.5 last:pr-0 hover:text-white no-underline"
      activeClassName="text-white"
      partiallyActive={false}
      to={to}
      title={title}
    >
      {children}
    </LocaleLink>
  )
}
